<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-links">
          <h3>友情链接</h3>
          <a href="https://www.moejam.com/" target="_blank">动漫资讯</a>
          <!-- <a href="https://cg-csdl.com/" target="_blank">动漫衍生品商城</a> -->
        </div>
        
        <div class="footer-contact">
          <h3>联系我们</h3>
          <p>QQ: 458150017</p>
          <p>开发人员: 范俊杰、白玉先</p>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>版权声明：本网站仅限内部使用，资源来源于互联网收集整理，仅供学习交流，如果喜欢请支持正版。如有问题，请发邮件到QQ邮箱</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterView'
}
</script>

<style scoped>
.footer {
  background-color: var(--bg-light, #f8f8f8);
  padding: 40px 0 20px;
  margin-top: 50px;
  color: var(--text-color, #333333);
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
}

.footer-links, .footer-contact {
  margin-bottom: 20px;
}

.footer-links h3, .footer-contact h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  position: relative;
  padding-bottom: 10px;
  letter-spacing: 0.5px;
  color: #2c3e50;
}

.footer-links h3::after, .footer-contact h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background-color: var(--primary-color, #4285f4);
}

.footer-links a {
  display: block;
  margin-bottom: 10px;
  color: #5f6368;
  transition: color 0.3s ease, transform 0.3s ease;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
}

.footer-links a:hover {
  color: var(--primary-color, #4285f4);
  transform: translateX(5px);
}

.footer-contact p {
  margin: 0 0 10px;
  color: #5f6368;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
}

.footer-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 20px;
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  font-size: 14px;
  color: #7a7a7a;
  line-height: 1.6;
  font-weight: 400;
}

@media screen and (max-width: 768px) {
  .footer {
    padding: 30px 0 15px;
  }
  
  .footer-top {
    flex-direction: column;
  }
  
  .footer-links, .footer-contact {
    width: 100%;
  }
  
  .footer-links h3, .footer-contact h3 {
    font-size: 17px;
  }
  
  .footer-links a, .footer-contact p {
    font-size: 14px;
  }
  
  .footer-bottom p {
    font-size: 13px;
  }
}
</style>